// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Azioni aperte (vista raggruppata con filtri e quick-action) ======

// Stato locale della vista
const _azioniState = {
  filterStato: '',
  filterCPL: '',
  filterPM1: '',
  filterPM2: '',
  filterRisorsa: '',
  groupBy: 'cliente', // 'cliente' | 'risorsa' | 'cpl'
  expanded: new Set() // chiavi dei gruppi aperti
};

const STATUS_NEXT_HINT = {
  'Da richiedere': 'Richieste', // hint: ho richiesto l'utenza, ora è "in attesa"
  Richieste: 'Sì', // hint: l'ho ricevuta, ora è attiva
  'Da eliminare': 'Eliminato' // hint: ho fatto la rimozione
};

function renderAzioni() {
  if (!isAdmin()) return;
  if (!$('#azioniContainer')) return; // vista "azioni" lazy non ancora montata
  wireAzioniView();

  const actions = collectActions(); // [{cliente, risorsa, stato, cpl}]

  // KPI
  const counts = { 'Da richiedere': 0, Richieste: 0, 'Da eliminare': 0 };
  actions.forEach((a) => {
    if (counts[a.stato] !== undefined) counts[a.stato]++;
  });
  $('#kpiAzDaRichiedere').textContent = counts['Da richiedere'];
  $('#kpiAzRichieste').textContent = counts['Richieste'];
  $('#kpiAzDaEliminare').textContent = counts['Da eliminare'];

  // Popola filtri (CPL/PM1/PM2 distinti, risorse)
  const cpls = [...new Set(actions.map((a) => a.cpl).filter(Boolean))].sort();
  const pm1s = [...new Set(actions.map((a) => a.pm1).filter(Boolean))].sort();
  const pm2s = [...new Set(actions.map((a) => a.pm2).filter(Boolean))].sort();
  fillSelect($('#filterAzCPL'), cpls, 'Tutti i Client Partner&Lead');
  fillSelect($('#filterAzPM1'), pm1s, 'Tutti i Project Manager 1');
  fillSelect($('#filterAzPM2'), pm2s, 'Tutti i Project Manager 2');
  fillSelect($('#filterAzRisorsa'), state.resources, 'Tutte le risorse');

  // KPI attivo (visivamente)
  $$('.kpi-clickable').forEach((el) => {
    el.classList.toggle('active', el.dataset.statoFilter === _azioniState.filterStato);
  });

  // Applica filtri
  let list = actions;
  if (_azioniState.filterStato) list = list.filter((a) => a.stato === _azioniState.filterStato);
  if (_azioniState.filterCPL) list = list.filter((a) => a.cpl === _azioniState.filterCPL);
  if (_azioniState.filterPM1) list = list.filter((a) => a.pm1 === _azioniState.filterPM1);
  if (_azioniState.filterPM2) list = list.filter((a) => a.pm2 === _azioniState.filterPM2);
  if (_azioniState.filterRisorsa)
    list = list.filter((a) => a.risorsa === _azioniState.filterRisorsa);

  const root = $('#azioniContainer');
  if (!list.length) {
    root.innerHTML = `<div class="azioni-empty">${actions.length ? 'Nessuna azione corrisponde ai filtri.' : 'Nessuna azione aperta.'}</div>`;
    return;
  }

  // Raggruppa
  const groupKeyFn = {
    cliente: (a) => a.cliente,
    risorsa: (a) => a.risorsa,
    cpl: (a) => a.cpl || '(senza CPL)'
  }[_azioniState.groupBy];

  const groups = new Map();
  list.forEach((a) => {
    const key = groupKeyFn(a);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(a);
  });

  // Ordina gruppi: più voci in cima
  const sortedGroups = [...groups.entries()].sort((a, b) => b[1].length - a[1].length);

  root.innerHTML = sortedGroups
    .map(([groupKey, items]) => {
      const isOpen = _azioniState.expanded.has(groupKey);
      const c = { 'Da richiedere': 0, Richieste: 0, 'Da eliminare': 0 };
      items.forEach((it) => {
        if (c[it.stato] !== undefined) c[it.stato]++;
      });

      let metaSecondary = '';
      if (_azioniState.groupBy === 'cliente') {
        const cpl = items[0].cpl;
        metaSecondary = cpl ? ` · CPL: ${escapeHtml(cpl)}` : ' · senza CPL';
      } else if (_azioniState.groupBy === 'risorsa') {
        const uniqClienti = new Set(items.map((it) => it.cliente)).size;
        metaSecondary = ` · ${uniqClienti} client${uniqClienti === 1 ? 'e' : 'i'}`;
      } else {
        const uniqClienti = new Set(items.map((it) => it.cliente)).size;
        metaSecondary = ` · ${uniqClienti} client${uniqClienti === 1 ? 'e' : 'i'}`;
      }

      const rowsHtml = items.map((it) => renderAzioneRow(it)).join('');

      return `
      <div class="azioni-group ${isOpen ? 'open' : ''}" data-group-key="${escapeHtml(groupKey)}">
        <div class="azioni-group-header">
          <svg class="azioni-group-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
          <span class="azioni-group-title">${escapeHtml(groupKey)}</span>
          <span class="azioni-group-counts">
            ${c['Da richiedere'] ? `<span class="azioni-count-pill warn">${c['Da richiedere']} da richiedere</span>` : ''}
            ${c['Richieste'] ? `<span class="azioni-count-pill info">${c['Richieste']} richieste</span>` : ''}
            ${c['Da eliminare'] ? `<span class="azioni-count-pill danger">${c['Da eliminare']} da eliminare</span>` : ''}
          </span>
          <span class="azioni-group-meta">${items.length} azion${items.length === 1 ? 'e' : 'i'}${metaSecondary}</span>
        </div>
        <div class="azioni-group-body">
          ${rowsHtml}
        </div>
      </div>`;
    })
    .join('');

  // Click sul header gruppo → toggle
  root.querySelectorAll('.azioni-group').forEach((el) => {
    el.querySelector('.azioni-group-header').addEventListener('click', () => {
      const key = el.dataset.groupKey;
      if (_azioniState.expanded.has(key)) _azioniState.expanded.delete(key);
      else _azioniState.expanded.add(key);
      el.classList.toggle('open');
    });
  });

  // Bind quick-action dropdown
  root.querySelectorAll('.azione-stato-select').forEach((sel) => {
    sel.addEventListener('change', async (e) => {
      e.stopPropagation();
      const row = sel.closest('.azione-row');
      const cliente = row.dataset.cliente;
      const risorsa = row.dataset.risorsa;
      const nuovoStato = sel.value;
      await quickChangeStato(cliente, risorsa, nuovoStato);
    });
    sel.addEventListener('click', (e) => e.stopPropagation()); // non collassare il gruppo
  });

  // Bind "Apri cliente"
  root.querySelectorAll('[data-open-cliente]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      openModal(btn.dataset.openCliente, 'accessi');
    });
  });
}

function renderAzioneRow(it) {
  let primaryLabel, secondary;
  if (_azioniState.groupBy === 'cliente') {
    primaryLabel = it.risorsa;
    secondary = it.cpl ? `CPL: ${it.cpl}` : '';
  } else if (_azioniState.groupBy === 'risorsa') {
    primaryLabel = it.cliente;
    secondary = it.cpl ? `CPL: ${it.cpl}` : '';
  } else {
    primaryLabel = it.cliente;
    secondary = it.risorsa;
  }

  const options = STATUS_OPTIONS.filter((s) => s !== '')
    .map(
      (s) => `
    <option value="${escapeHtml(s)}" ${s === it.stato ? 'selected' : ''}>${escapeHtml(s)}</option>`
    )
    .join('');

  return `
    <div class="azione-row" data-cliente="${escapeHtml(it.cliente)}" data-risorsa="${escapeHtml(it.risorsa)}">
      <span class="a-status"><span class="status ${statusClass(it.stato)}">${escapeHtml(it.stato)}</span></span>
      <span class="a-name">${escapeHtml(primaryLabel)}</span>
      <span class="a-secondary">${escapeHtml(secondary)}</span>
      <div class="azione-actions">
        <select class="azione-stato-select" title="Cambia stato">${options}</select>
        <button type="button" class="btn-link" data-open-cliente="${escapeHtml(it.cliente)}" title="Apri scheda cliente">Apri →</button>
      </div>
    </div>`;
}

async function quickChangeStato(cliente, risorsa, nuovoStato) {
  // Trova vecchio stato per audit
  const cli = state.clients.find((c) => c.nome === cliente);
  const vecchioStato = cli?.accessi?.[risorsa] || '';
  if (vecchioStato === nuovoStato) return;

  try {
    await api.updateAccessStato(cliente, risorsa, nuovoStato);
    logAudit({
      action: 'update',
      entity: 'Cliente',
      target: cliente,
      changes: [{ field: `Accesso · ${risorsa}`, from: vecchioStato, to: nuovoStato }]
    });
    // S2: invalidazione selettiva su singolo cliente
    await refreshClient(cliente);
    renderAzioni();
    renderDashboard();
    toast(`Stato aggiornato: ${risorsa} → ${nuovoStato || '(rimosso)'}`);
  } catch (err) {
    console.error(err);
    toast('Errore: ' + (err.message || err));
    renderAzioni();
  }
}

// ====== Event listeners — wiring idempotente (la vista "azioni" è lazy) ======
// Si esegue una sola volta, dopo che il fragment è stato iniettato. Tutti gli
// accessi al DOM sono guardati così il modulo non rompe il boot se la vista
// non è ancora montata.
let _azioniWired = false;
function wireAzioniView() {
  if (_azioniWired) return;
  if (!document.getElementById('azioniContainer')) return; // vista non ancora montata

  $$('.kpi-clickable').forEach((el) => {
    el.addEventListener('click', () => {
      const stato = el.dataset.statoFilter;
      // Toggle: se è già attivo, deseleziona
      _azioniState.filterStato = _azioniState.filterStato === stato ? '' : stato;
      const fs = $('#filterAzStato');
      if (fs) fs.value = _azioniState.filterStato;
      renderAzioni();
    });
  });

  const onFilter = (id, key) => {
    const el = document.getElementById(id);
    if (el)
      el.addEventListener('change', (e) => {
        _azioniState[key] = e.target.value;
        renderAzioni();
      });
  };
  onFilter('filterAzStato', 'filterStato');
  onFilter('filterAzCPL', 'filterCPL');
  onFilter('filterAzPM1', 'filterPM1');
  onFilter('filterAzPM2', 'filterPM2');
  onFilter('filterAzRisorsa', 'filterRisorsa');

  // Solo i bottoni "Raggruppa per" (hanno data-group): NON il toggle
  // Lista/Kanban che kanban.js inietta nella stessa barra filtri.
  $$('#view-azioni .segmented button[data-group]').forEach((btn) => {
    btn.addEventListener('click', () => {
      $$('#view-azioni .segmented button[data-group]').forEach((b) =>
        b.classList.toggle('active', b === btn)
      );
      _azioniState.groupBy = btn.dataset.group;
      _azioniState.expanded.clear(); // cambiare raggruppamento azzera lo stato espansione
      renderAzioni();
    });
  });

  const bExpand = document.getElementById('btnAzExpandAll');
  if (bExpand)
    bExpand.addEventListener('click', () => {
      $$('#azioniContainer .azioni-group').forEach((g) => {
        g.classList.add('open');
        _azioniState.expanded.add(g.dataset.groupKey);
      });
    });
  const bCollapse = document.getElementById('btnAzCollapseAll');
  if (bCollapse)
    bCollapse.addEventListener('click', () => {
      $$('#azioniContainer .azioni-group').forEach((g) => g.classList.remove('open'));
      _azioniState.expanded.clear();
    });

  _azioniWired = true;
}
wireAzioniView(); // no-op finché la vista lazy non è montata
// Ri-wiring quando il fragment lazy viene iniettato (anche via preload)
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'azioni') wireAzioniView();
});

Object.assign(globalThis, { renderAzioni, quickChangeStato, wireAzioniView });
export {};
